module.exports = __webpack_public_path__ + "img/after school as usual.7632beb6.png";